import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaUserCircle,
  FaMapMarkedAlt,
  FaEnvelope,
  FaSignInAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { FaUserShield } from "react-icons/fa";
import "./Navbar.css";

export default function Navbar() {
  const [user, setUser] = useState(null);

  // 🔥 états séparés
  const [isMenuOpen, setIsMenuOpen] = useState(false);       // mobile
  const [isProfileOpen, setIsProfileOpen] = useState(false); // dropdown PC

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  // Fermer le dropdown profil si clic extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/page accueil");
  };

  const iconStyle = { marginRight: "0.5rem" };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/logo.png" alt="Logo" className="logo" />
      </div>

      {/* ☰ Hamburger (mobile seulement via CSS) */}
      <div
        className="hamburger"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* MENU (PC inchangé) */}
      <ul className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
        <li>
          <Link to="/Mapview" className="active">
            <FaMapMarkedAlt style={iconStyle} /> Géoportail
          </Link>
        </li>

        <li>
          <Link to="/admin">
            <FaUserShield style={iconStyle} /> Espace Admin
          </Link>
        </li>

        <li>
          <Link to="/contact">
            <FaEnvelope style={iconStyle} /> Contact
          </Link>
        </li>

        {!user ? (
          <li>
            <Link to="/page accueil">
              <FaSignInAlt style={iconStyle} /> Connexion
            </Link>
          </li>
        ) : (
          <li className="navbar-profile" ref={dropdownRef}>
            <Link
              to="/profile"
              className="profile-link"
              onClick={(e) => {
                e.preventDefault();
                setIsProfileOpen(!isProfileOpen);
              }}
            >
              <FaUserCircle size={20} style={iconStyle} />
              <span>{user.name}</span>
            </Link>

            {isProfileOpen && (
              <div className="profile-dropdown">
                <div className="avatar">
                  {user.name.charAt(0).toUpperCase()}
                </div>

                <div className="profile-item">
                  <strong>{user.name}</strong>
                </div>

                <div className="profile-item">{user.email}</div>

                <div
                  className="logout-item"
                  onClick={handleLogout}
                >
                  <FiLogOut /> Déconnexion
                </div>
              </div>
            )}
          </li>
        )}
      </ul>
    </nav>
  );
}
